import { combineEpics } from "redux-observable";
import { epicTimeBalloonOffer } from "./epics/epicTimeBalloonOffer";
import { epicTimeConstruction } from "./epics/epicTimeConstruction";
import { epicTimeContractInfo } from "./epics/epicTimeContractInfo";
import { epicTimeCoopProject } from "./epics/epicTimeCoopProject";
import { epicTimeDoghouseFreeTreat } from "./epics/epicTimeDoghouseFreeTreat";
import { epicTimeEvents } from "./epics/epicTimeEvents";
import { epicTimeMarketCooldown } from "./epics/epicTimeMarketCooldown";
import { epicTimeProduction } from "./epics/epicTimeProduction";
import { epicTimePurchasePointsEvent } from "./epics/epicTimePurchasePointsEvent";
import { epicTimeShop } from "./epics/epicTimeShop";
export var epicTime = combineEpics(epicTimeConstruction, epicTimeProduction, epicTimeMarketCooldown, epicTimeContractInfo, epicTimeEvents, epicTimePurchasePointsEvent, epicTimeShop, epicTimeDoghouseFreeTreat, epicTimeCoopProject, epicTimeBalloonOffer);



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epicTime.ts
// module id = 2429
// module chunks = 3